import { render } from "./HeroiconsOutlineTable.vue?vue&type=template&id=3f1aad10"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTable.vue"]])

export default __exports__